module.exports = __webpack_public_path__ + "img/picture-place.811a84a9.png";